
export default {
  apiKey: "AIzaSyC1c6Fr0HmWLhA5ZVA64vu8HsfRl5UCOZQ",
  authDomain: "notes-at.firebaseapp.com",
  databaseURL: "notes-at.firebaseio.com",
  projectId: "notes-at",
  storageBucket: "notes-at.appspot.com",
  messagingSenderId: "381674245730"
}
